import React from 'react';
import Notiflix from 'notiflix';
import { showLoader, hideLoader } from '../loader/brandLoader';

export const notiflixLoaderStart = () => {
    Notiflix.Notify.Init({ width: '300px', fontSize: '14px', timeout: 4000, messageMaxLength: 200, });
    showLoader();
}

export const notiflixLoaderEnd = () => {
    hideLoader();
    Notiflix.Loading.Remove()
}

export const notiflixStatus = (status, msg) => {
    if (status) {
        hideLoader()
        Notiflix.Loading.Remove()
        Notiflix.Notify.Success(msg)
    }
    else {
        hideLoader()
        Notiflix.Loading.Remove()
        Notiflix.Notify.Failure(msg)
    }

}

export const notificationStatus = (result) => {
    
    hideLoader()
    Notiflix.Loading.Remove()
    if (result.status) {
        Notiflix.Notify.Success(result.message)
    }
    else {        
        Notiflix.Notify.Failure(result.message)
    }

}

//RealTime Notifications
export const realTimeNotification = (status, msg) => {
    if (status) {
        hideLoader()
        Notiflix.Loading.Remove()
        Notiflix.Notify.Success(msg)
    }
    else {
        console.log("asdsad")
        hideLoader()
        Notiflix.Loading.Remove()
        Notiflix.Notify.Failure(msg)
    }

}

//Informative Notifications
